<template>
  <ul class="error-list" v-show="errors">
    <li v-for="msg in errors" :key="msg">{{ msg }}</li>
  </ul>
</template>

<script>
export default {
  name: 'error-list',
  props: {
    errors: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style>
.error-list {
  color: red;
}

.error-list li {
  list-style: none;
}

</style>



// WEBPACK FOOTER //
// src/parts/ErrorList.vue